import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import { HttpMethod, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
export class DiscoveryApiRequestFactory extends BaseAPIRequestFactory {
    async invokeDiscover(projectId, accountId, discoveryInvokeParams, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("DiscoveryApi", "invokeDiscover", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("DiscoveryApi", "invokeDiscover", "accountId");
        }
        if (discoveryInvokeParams === null || discoveryInvokeParams === undefined) {
            throw new RequiredError("DiscoveryApi", "invokeDiscover", "discoveryInvokeParams");
        }
        const localVarPath = '/projects/{projectId}/accounts/{accountId}/invoke-discovery'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(discoveryInvokeParams, "DiscoveryInvokeParams", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class DiscoveryApiResponseProcessor {
    async invokeDiscoverWithHttpInfo(response) {
        if (isCodeInRange("202", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Message", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = ObjectSerializer.deserialize(await response.body.json(), "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
